const DETALHES = [
  { label: 'Contrato', value: '458721' },
  { label: 'Empresa', value: 'Empresa XYZ' },
  { label: 'Produto', value: 'Plano Empresarial' },
  { label: 'Vidas', value: '48' },
  { label: 'Corretor', value: 'João Silva' },
  { label: 'Campanha', value: 'Incentivo Comercial PME' },
  { label: 'Competência', value: 'Agosto/2026' },
  { label: 'Valor elegível', value: 'R$ 350' },
];

export default function DiscriminacaoCredito() {
  return (
    <section id="credito" className="scroll-mt-28 bg-background-100 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-6">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-accent-700">
              <i className="ri-fingerprint-line"></i>
              Diferencial GetPoints
            </span>
            <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-5xl">
              Cada premiação tem uma origem.
              <br />
              <span className="text-accent-600">Cada crédito pode ser rastreado.</span>
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600">
              Com a <strong className="font-semibold text-foreground-900">Discriminação de Crédito</strong>, a GetPoints
              relaciona a premiação às informações que deram origem ao crédito — contrato, empresa, produto, vidas,
              corretor e campanha. Isso cria uma trilha de auditoria da premiação, proporcionando maior transparência
              operacional e controle da campanha para administradoras, operadoras, corretoras, equipes comerciais,
              auditoria, financeiro e controladoria.
            </p>

            <ul className="mt-8 space-y-3">
              {[
                'Trilha de auditoria completa da origem de cada premiação',
                'Controle de elegibilidade vinculado aos contratos comercializados',
                'Transparência para auditoria, financeiro e controladoria',
                'Conformidade e rastreabilidade em cada crédito gerado',
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm text-foreground-700">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="lp-float-soft">
            <div className="mx-auto max-w-md rounded-3xl border border-background-200 bg-background-50 p-6 md:p-8">
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
                  <i className="ri-add-line"></i>
                  Premiação gerada
                </span>
                <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
                  Elegível
                </span>
              </div>

              <p className="mt-6 font-heading text-5xl font-bold leading-none text-primary-600">+ 2.500</p>
              <p className="mt-1 text-sm font-medium text-foreground-500">pontos</p>

              <div className="mt-7 space-y-0 divide-y divide-background-200 rounded-2xl border border-background-200">
                {DETALHES.map((item) => (
                  <div key={item.label} className="flex items-center justify-between px-4 py-3">
                    <span className="text-xs font-medium text-foreground-500">{item.label}</span>
                    <span className="text-right text-sm font-semibold text-foreground-900">{item.value}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}